<template>
  <div style="height:172px">
    <div class="cont" :class="navBarFixed == true ? 'active' :''">
      <div style="height:50px;background-color:#333">

      </div>
      <!-- <el-carousel trigger="click" height="547px" :interval="5000" :autoplay="false">


        <el-carousel-item v-for="item in 4" :key="item"></el-carousel-item>
      </el-carousel>-->
      <div class="inner" >
        <div class="inner-item" >
          <el-container>
            <router-link :to="{ name: 'Home' }">
              <el-aside  class="aside" :style="{ backgroundImage : 'url( '+ pc_logo_home + ')'   }"  style="width: 270px; height:84px;margin-right:30px"></el-aside>
            </router-link>
            <el-main style="overflow:hidden;padding:0" class="amain">
                <router-link :to="{ name: 'Home' }" tag="div">
                  <span class="item" style="margin : 0 14px">首页</span>
                </router-link>
                <router-link :to="{ path: '/user/order' }" tag="div">
                  <span class="item" style="margin : 0 14px">我的订单</span>
                </router-link>
                <router-link :to="{ path: '/user' }" tag="div">
                  <span class="item" style="margin : 0 14px">会员中心</span>
                </router-link>
                <router-link :to="{ path: '/conponCenter' }" tag="div">
                  <span class="item" style="margin : 0 14px">优惠券</span>
                </router-link>

                <!-- <span class="item" style="margin : 0 14px" @click="kefu">在线客服</span> -->

                <el-popover placement="bottom" width="200" trigger="hover">
                  <div>
                    <el-image
                        style="width: 200px; height: 200px;"
                        :src=" this.common.publicUrl + '/profile/avatar/u29.png' "
                        fit="contain">
                    </el-image>
                  </div>
                  <span class="item" style="margin : 0 14px" slot="reference">手机平台</span>
                </el-popover>

                <el-popover
                  style="margin:0 20px;flex:1;text-align:right;"
                  placement="bottom"
                  width="335"
                  trigger="hover">
                  <div style="padding:15px;box-sizing:border-box;font-size: 12px;" >
                    <!-- 商品信息 -->
                    <div class="outer-container">
                      <div class="inner-container">
                        <div
                          style="display:flex"
                          v-for="(item, idx) in cartItemlist"
                          :key="idx"
                        >
                          <div style="width:80px;margin-right:10px">
                            <el-image
                              style="width: 80px; height: 80px;"
                              :src=' publicUrl  + item.goodsPic'
                              fit="contain">
                            </el-image>
                          </div>
                          <div style="flex:1;">
                            <div style="display:flex;align-items:center">
                              <div style="flex:1;color: #333333;" v-if="moduleUser.goods_visible == '1' ">{{ item.goodsName }}</div>
                              <div style="flex:1;color: #333333;" v-else-if="moduleUser.goods_visible == '0' ">{{ item.specification }}</div>


                              <div style="color: #D10217;">¥{{ item.discountPrice }} x{{ item.quantity }}</div>
                              <i class="el-icon-close" style="margin:0 5px;font-size:12px;cursor : pointer" @click.stop="slideButtonTap( idx )"></i>
                            </div>
                            <div style="color:#999;margin-top:5px;">
                              <div >{{item.searchValue?'适配：'+item.searchValue:'' }}</div>
                              <div>{{item.vin?'车架号：'+item.vin:'' }} </div>
                            </div>

                          </div>
                        </div>

                      </div>
                    </div>


                    <!-- 价格信息 -->
                    <div style="display:flex;align-items:center;margin-top:5px">
                      <div style="flex:1">
                        <div style="font-size: 12px;color: #666666;margin-bottom:3px">共{{ cartItemlist.length }}件商品</div>
                        <div style="font-size: 18px;color: #D10217;">{{ totalPrice }}元</div>
                      </div>
                      <router-link :to="{ path: '/shopCar' }"  tag="div">
                        <div
                          class="background_style btn"
                          style="width:150px;cursor : pointer"
                          :style="{backgroundImage: 'url(' + btn_red + ')' }"
                        >
                          去购物车结算
                        </div>
                      </router-link>
                    </div>
                  </div>
                  <el-badge :value=" cartItemlist.length " style="border:none;" slot="reference">
                    <router-link :to="{ path: '/shopCar' }" >
                      <el-button size="small"  style="border:none;font-size: 14px;color: #999999 " >
                        <i class="el-icon-shopping-cart-2" style="font-size:16px;color:#ff2c2c"></i>
                        我的购物车
                      </el-button>
                    </router-link>
                  </el-badge>

                </el-popover>

<!--                <el-image-->
<!--                  style="position:fixed;right:20px;top:80px;height:50px;width:50px;cursor : pointer"-->
<!--                  class="product_image"-->
<!--                  :src=' contactImg '-->
<!--                  fit="contain"-->
<!--                  @click.stop="kefu"-->
<!--                ></el-image>-->
              <el-popover placement="bottom" width="180"  trigger="click"  style="position:fixed;right:100px;top:80px;height:50px;width:50px;cursor : pointer">
                <div style="text-align: center;" id="qrcode">

                </div>
                <div style="text-align: center;font-weight: bold;font-size: 16px;margin-top: 5px"  >打开微信扫一扫</div>
                <span class="item" style="margin : 0 14px" slot="reference">
                  <el-image class="product_image" :src='contactImg' @click="kefu" ></el-image>
                </span>
              </el-popover>
            </el-main>
          </el-container>
        </div>
      </div>
    </div>
  </div>

</template>

<script>

import {
  getCartItemlistReq ,
  delCartItemReq
} from "@/api/shoppingCart/index";
import QRCode from 'qrcodejs2';

export default {
  name: "ContOne" ,
  data() {
    return {
      navBarFixed : false  ,  //是否吸顶
      input3 : '' ,
      logoImg :  this.common.publicUrl + '/profile/avatar/u39.png' ,
      pc_logo_home : this.common.publicUrl + '/profile/avatar/pc_logo_home.png' ,
      btn_red : this.common.publicUrl + '/profile/avatar/u35.png' ,
      contactImg :  this.common.publicUrl + '/profile/avatar/u480.png' ,
      cartItemlist : []  , //购物车列表
      totalPrice : 0 , //总价
      totalGoodPrice : 0 ,  //原总价
      publicUrl : this.common.publicUrl ,
      qrCode:undefined,
    }
  },
  created(){
    this.getCartItemlist()


  } ,
  mounted () {
    // 事件监听滚动条
    window.addEventListener('scroll', this.watchScroll)
  },
  destroyed(){
    window.removeEventListener('scroll', this.watchScroll);
  },
  computed : {
    moduleUser() {
      return this.$store.state.moduleUser; // 这里返回的是：{name: 'wang', age: 22}
    } ,
    cart_refresh() {
      return this.$store.state.cart_refresh;
    }
  },
  methods: {
    getCartItemlist(){
      getCartItemlistReq().then( res => {
        if (res.data.status == 0) {
          let cartItems = res.data.cartItems ;
          this.cartItemlist = cartItems
          this.calcTotalPrice()
          this.$store.commit('cart_refresh_close');
        } else {
          this.$message.error(res.data.statusDesc);
        }
      })
    },
    //计算所有价格
    calcTotalPrice(){
      let cartItemlist = this.cartItemlist ;
      let totalPrice = 0 ;
      let totalGoodPrice = 0 ;
      cartItemlist.forEach( (val  ) => {
        if(  val.discountPrice ){
          totalPrice += val.quantity * val.discountPrice
          totalGoodPrice += val.quantity * val.goodsPrice
        }
      })
      this.totalPrice = totalPrice.toFixed(2)
      this.totalGoodPrice = totalGoodPrice.toFixed(2)
    } ,
    watchScroll () {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      //当滚动超过 115 时，实现吸顶效果
      if (scrollTop > 172) {
        this.navBarFixed = true
      } else {
        this.navBarFixed = false
      }
    } ,
    //删除单个产品
    slideButtonTap( idx ){
      let index = idx
      let cartIds = this.cartItemlist[index].cartId ;
      let cartItemlist = this.cartItemlist ;

      delCartItemReq({
        cartIds : cartIds ,
      }).then( res => {
        if( res.data.status == 0 ){
          cartItemlist.splice( index , 1 )
          this.cartItemlist = cartItemlist
          this.calcTotalPrice()
        }

      } )
    },
    //点击客服
    kefu(){
      //window.open( 'https://wpa1.qq.com/mgPSf1RA?_type=wpa&qidian=true' , '_blank');

      let wxkfurl= this.moduleUser.wxkfurl;
      if(this.qrCode){
        this.qrCode.clear()
      }else{

        this.qrCode = new QRCode("qrcode", {
          width: 180,//二维码宽度，单位像素
          height: 180,//二维码高度，单位像素
          text: wxkfurl, //二维码中的内容
          colorDark : '#000000',//前景色
          colorLight : '#ffffff',//背景色
          correctLevel : QRCode.CorrectLevel.H //容错级别，
        })
      }
    }
  } ,
  watch : {
    cart_refresh( newName ){
      if( newName ){
        this.getCartItemlist()
      }
    }
  }

};
</script>

<style lang="stylus" scoped>
.cont.active{

}
.cont {
  position:fixed;
  z-index:2000;
  background-color : rgba(255, 255, 255 , 100%);
  width : 100% ;
  margin: 0 auto;
  top: 0 ;

  color: #000;
  background-repeat : no-repeat
  background-size : cover
  // position : relative
  box-sizing: border-box;
  border-bottom 1px solid lightgray
  background-color #fff
}
  .inner.active{
    position:fixed;
    z-index:999;
    background-color : rgba(255, 255, 255 , 100%);
    margin: 0 auto;
  }
  .inner {
    padding: 19px 10px;
    box-sizing: border-box;
    background-color : rgba(0, 0, 0 , 0%)
    width : 1200px ;
    margin: 0 auto;
  }

    .inner-item {
      border-bottom: 1px solid #fff;
      height: 82px;
    }

      .aside {
        overflow: hidden;
        width: 229px;
        height: 82px;
        background-color: #fff;
        background: url("~@/assets/image/home/home1/LOGO.png");
        background-repeat : no-repeat
        background-size : cover
      }

      .amain {
        overflow: hidden;
        padding: 0;
        font-size: 15px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: rgba(0, 0, 0, 1);
        display: flex;
        justify-content: flex-start;
        align-items : center ;
      }
       .input-with-select{
         flex:1 ;
         border-radius : 10px
       }
.item{
  font-size: 16px;
  font-weight: 700;
  color: #404040;

}
.item:hover{
  color : #f90000
  font-style  : normal ;
  cursor pointer
}
.cart_cont{
  max-height:300px;
  overflow-y:auto
}

.outer-container{
	height:300px;
	position: relative;
	overflow: hidden;
}
.inner-container{
	position: absolute;
	left: 0;
	top: 0;
	right: -17px;
	bottom: 0;
	overflow-x: hidden;
	overflow-y: scroll;
}
</style>
